var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPiggvar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96.88 71.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: url(#Namnl\xF6s_\xF6vertoning_284-2);\n      }\n\n      .cls-3 {\n        fill: url(#Namnl\xF6s_\xF6vertoning_284);\n      }\n\n      .cls-4 {\n        fill: url(#Namnl\xF6s_\xF6vertoning_286);\n      }\n\n      .cls-5 {\n        fill: url(#Namnl\xF6s_\xF6vertoning_291);\n      }\n\n      .cls-6 {\n        fill: #4c422f;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_291",
    "data-name": "Namnl\\xF6s \\xF6vertoning 291",
    x1: -1451.78,
    y1: 31.53,
    x2: -1437.88,
    y2: 31.53,
    gradientTransform: "translate(-1437.83) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a5c43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7a996"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_284",
    "data-name": "Namnl\\xF6s \\xF6vertoning 284",
    cx: -1490.71,
    cy: 36.44,
    fx: -1490.71,
    fy: 36.44,
    r: 41.84,
    gradientTransform: "translate(-1437.83 16.8) rotate(-180) scale(1 -.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#b7a996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#aea08c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#968872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#6f6149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5c43"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_284-2",
    "data-name": "Namnl\\xF6s \\xF6vertoning 284",
    cx: -1486.95,
    cy: 10.3,
    fx: -1486.95,
    fy: -17.65,
    r: 27.96,
    gradientTransform: "translate(-1437.83 6.73) rotate(-180) scale(1 -.35)",
    xlinkHref: "#Namnl\\xF6s_\\xF6vertoning_284"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_286",
    "data-name": "Namnl\\xF6s \\xF6vertoning 286",
    cx: -1485.57,
    cy: 59.31,
    fx: -1485.57,
    fy: 59.31,
    r: 34.9,
    gradientTransform: "translate(-1437.83 38.75) rotate(-180) scale(1 -.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#b7a996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#aea08c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#968872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6f6149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#6a5c43"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Showing_animals",
    "data-name": "Showing animals"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m13.7,26.13l-2.58-1.45-3.89-1.94c-.46-.23-3.89-.46-3.89-.46l-1.32,1.48-.22,1.08.1,1.72-1.1,2.48-.2,1.73-.47,2.1v1.47s.33,1.69.33,1.69c0,0,.29,1.28.26,1.6s-.68,3.13-.68,3.13l5.58-.76,3.98-.82s1.55-1.17,1.28-1.58-.34-1.72-.34-1.72l.34-.8s.77-1.5.69-1.72,0-1.14,0-1.14l.34-.8s.84-.48.46-.92c-.71-.81.69-1.26.69-1.26l.89-.97-.25-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m78.37,23.46c-.47-.31-5.04-3.78-5.04-3.78l-7.24-3.78s-3.78-1.73-4.25-1.89-8.65-.47-8.65-.47l-7.24.94-7.55,3.15-8.02,3.93-6.45,4.25s-4.56,2.05-5.04,2.05-5.19-1.73-5.19-1.73l-1.57,2.05-.64,3.11-1.52,3.85-.36,4.06,5.19.16,4.88,1.42,2.99,2.99,5.19,4.72,5.19,5.04,4.25,2.2,3.78,1.89,4.72,1.26,5.51.47,7.87-1.89,6.77-1.57,6.77-1.42,5.82-2.67s5.98-2.52,6.45-2.52,6.29-3.78,6.29-3.78l2.05-2.67-5.04.31.31-2.05,2.52-1.73,3.46-2.36,1.57-2.2-4.41-2.36-5.66-3.3-2.67-1.26-1.42-2.67-3.62-1.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.6 21.82 76.08 16.11 69.91 9.93 62.24 4.44 55.27 1.46 47.95 1.12 41.31 2.15 35.02 4.1 29.42 7.98 24.84 15.19 21.3 21.6 18.89 27.86 23.93 25.82 30.38 21.57 38.4 17.64 45.96 14.49 53.78 13.59 60.53 13.7 68.42 16.79 74.37 20.11 78.6 21.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m81.46,50.42l-4.46,2.06-7.21,2.75s-6.98,1.37-7.89,1.6-9.72,2.17-10.07,2.17-8.01-.46-8.01-.46l-7.32-2.86-6.29-4.46-7.89-6.52-2.06,3.66,2.86,5.38,2.06,4.92,3.55,5.38,4.23,4.58,8.12,2.4,6.75.34,8.12-1.94,3.89-2.17,7.43-2.75,5.26-4.35,4.12-4.8s3.09,2.4,2.97,1.83,2.17-4.8,2.17-4.8l-.34-1.94Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 54.12,
    cy: 20.91,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 40,
    cy: 22.57,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 41.26,
    cy: 30.35,
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 43.01,
    cy: 34.93,
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 51.41,
    cy: 26.75,
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 44.4,
    cy: 26.17,
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 62.42,
    cy: 26.11,
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 66.31,
    cy: 22.11,
    r: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 58.87,
    cy: 33.89,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 54.12,
    cy: 31.89,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 54.35,
    cy: 36.58,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 48.4,
    cy: 33.49,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 35.99,
    cy: 33.51,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 30.98,
    cy: 30.67,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 45.66,
    cy: 39.55,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 50.58,
    cy: 42.53,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 29.99,
    cy: 40.35,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 18.66,
    cy: 34.41,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 27.17,
    cy: 36.99,
    r: 1.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 29.82,
    cy: 28.06,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 39.37,
    cy: 52.14,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 45.94,
    cy: 54.37,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 53.09,
    cy: 55.22,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 80.29,
    cy: 43.18,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 85.67,
    cy: 45.51,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 80.79,
    cy: 40.34,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 80.17,
    cy: 32.4,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 82.73,
    cy: 31.03,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 58.87,
    cy: 50.82,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 61.79,
    cy: 46.59,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 56.34,
    cy: 45.68,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 49.32,
    cy: 46.93,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 45.99,
    cy: 43.59,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 53.91,
    cy: 42.59,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 65.41,
    cy: 44.93,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 68.75,
    cy: 48.34,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 70.25,
    cy: 39.92,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 64.58,
    cy: 34.42,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 63.5,
    cy: 53.28,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 72.65,
    cy: 49.73,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 80.98,
    cy: 47.16,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 77.85,
    cy: 44.84,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 76.92,
    cy: 35.5,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 78.79,
    cy: 37.71,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 70.02,
    cy: 44.02,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 69.79,
    cy: 33.49,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 76.67,
    cy: 40.4,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 63.16,
    cy: 30.98,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 76.08,
    cy: 26.97,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 70.37,
    cy: 22.97,
    r: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 48.8,
    cy: 50.36,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 39.54,
    cy: 48.65,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 33.76,
    cy: 48.7,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 29.19,
    cy: 44.13,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 42.17,
    cy: 43.39,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 36.62,
    cy: 39.44,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 23.07,
    cy: 38.01,
    r: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 15.86,
    cy: 32.18,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 21.98,
    cy: 30.25,
    r: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.46,24.94c.05-.03.11-.09.16-.13-.05.04-.11.1-.16.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.05,40.77c.08.22.38.53.54.52,1.49-.15,2.97-.34,4.45-.57,1.69-.27,3.36-.78,5.06-.84,1.72-.06,3.46.31,5.18.5.57.06,1.13.18,1.69.27.05,0,.11,0,.17,0,.88.01.71.93,1.14,1.33.39.36,1.24.45.77,1.33-.09.17-.11.53,0,.64.63.63.4,1.42.51,2.16.31,2.07.76,4.11,2.04,5.85.08.11.22.23.22.34.06,1.91,1.09,3.5,1.79,5.18.41.99,1.27,1.79,1.87,2.71.58.88,1.08,1.8,1.64,2.69.22.35.49.68.73,1.01.1.13.3.29.28.4-.19.97.64,1.53.9,2.31.04.12.12.26.22.33,1.7,1.26,3.28,2.63,5.34,3.43,2.24.87,4.52.98,6.81,1.24,1.34.15,2.71.02,4.05.21,2.29.31,4.49-.12,6.69-.55,1.89-.38,3.68-1.04,5.31-2.15.55-.37,1.38-.29,2.06-.49,1.15-.33,2.32-.62,3.41-1.1,1.39-.61,2.67-1.45,4.04-2.1,1.18-.55,2.33-1,3.09-2.22.44-.71,1.41-1.08,2.12-1.63.82-.64,1.67-1.25,2.4-1.99.52-.53.85-1.24,1.25-1.87.2-.31.38-.63.55-.92.66.79,1.23,1.52,1.86,2.2.09.1.54.02.7-.12,1.26-1.14,2.48-2.3,2.89-4.07.21-.91.61-1.78.8-2.69.17-.8.78-1.01,1.37-1.3,2.33-1.15,4.66-2.3,6.59-4.07,1.31-1.2,2.55-2.48,3.77-3.77.2-.21.27-.67.2-.96-.04-.17-.51-.38-.74-.33-.74.16-1.44.44-2.17.66-.19.06-.41.17-.58.13-.6-.13-1.19-.31-1.83-.49,1.36-1.18,2.39-2.76,4.12-3.66,1.36-.71,2.65-1.6,3.37-3.04.16-.32.23-.88.06-1.1-.19-.24-.71-.24-1.09-.32-.16-.03-.38.09-.49.02-.63-.41-1.22-.88-1.85-1.3-.28-.19-.63-.27-.93-.43-.47-.26-1.05-.44-1.37-.84-1.36-1.65-3.22-2.37-5.17-2.95-.25-.07-.46-.33-.63-.55-.85-1.09-1.61-2.28-2.56-3.28-.53-.56-1.49-.71-2.05-1.25-.51-.49-.81-1.24-1.11-1.92-.42-.96-.47-2.32-1.17-2.86-1.06-.81-.91-1.99-1.5-2.88-.25-.38-.52-.76-.81-1.12-.46-.57-.95-1.1-1.42-1.66-.35-.42-.6-.93-1.01-1.26-1.81-1.46-3.61-2.93-5.5-4.27-1.37-.97-2.89-1.72-4.32-2.61-.55-.34-1.03-.79-1.56-1.16-.41-.29-.82-.57-1.27-.78-1.53-.71-3.02-1.61-4.63-2.02-1.54-.4-3.21-.27-4.82-.39-1.31-.09-2.62-.15-3.92-.32-1.06-.14-1.99.21-2.96.48-1.25.35-2.53.6-3.75,1.03-.62.22-1.13.75-1.69,1.14.05.14.09.28.14.42.97-.04,1.96-.03,2.92-.15.86-.11,1.69-.39,2.54-.59.94-.21,1.15-.02,1.06.94-.02.22,0,.44.05.66.25,1.22.51,2.45.78,3.67.28,1.27.58,2.53.87,3.8.09.42.16.84.24,1.26.15,0,.29-.02.44-.03,0-.35.07-.71-.01-1.04-.32-1.37-.72-2.73-1.03-4.1-.22-.96-.36-1.94-.51-2.92-.11-.76-.18-1.54-.27-2.36.14-.05.33-.12.65-.24.17.5.35.97.49,1.45.36,1.23.71,2.46,1.06,3.68.04.13.08.27.06.4-.19,1.85.57,3.48,1.16,5.23-.59.08-1.19.1-1.75.25-.54.14-.77-.08-.89-.53-.29-1.15-.54-2.32-.86-3.47-.12-.42-.32-.87-.61-1.2-.85-.96-.93-2.17-1.22-3.33-.09-.37-.23-.73-.39-1.07-.05-.1-.27-.11-.41-.16-.04.14-.17.31-.12.41.68,1.53.82,3.23,1.72,4.72.64,1.06.82,2.39,1.2,3.6.11.36.2.73.32,1.16-.34.1-.67.25-1.02.29-.14.01-.43-.22-.43-.35,0-1.52-.77-2.77-1.3-4.11-.64-1.61-1.17-3.27-1.76-4.9-.08-.23-.25-.43-.38-.64-.09.04-.19.07-.28.11.1.43.15.88.29,1.3.5,1.43,1.03,2.86,1.57,4.28.38,1.01.79,2.01,1.17,3.02.36.94.24,1.78-.71,2.5-.44-.66-.89-1.34-1.34-2.02-.06-.09-.13-.26-.1-.3.91-.99-.01-1.84-.31-2.64-.34-.93-1.07-1.71-1.52-2.61-.37-.74-.59-1.56-.85-2.36-.11-.34-.18-.7-.27-1.05-.08,0-.15.01-.23.02-.06.17-.2.36-.15.49.33,1.05.62,2.13,1.06,3.13.57,1.29,1.28,2.52,1.92,3.77.07.15.21.36.16.46-.7,1.22.33,1.95.78,2.84.05.1.07.21.13.39-.39.16-.8.31-1.25.5-.97-1.22-1.3-2.75-1.82-4.2-.3-.85-.59-1.7-.92-2.53-.41-1.01-.86-1.99-1.29-3-.26-.61-.18-1.07.48-1.43.6-.32.8-1.13.48-1.59-.41-.57-.95-.31-1.5-.2-2.4.49-4.2,2.16-6.31,3.2-.1.05-.18.13-.25.21-1.43,1.72-3.37,2.92-4.46,5.03-1.48,2.85-3.22,5.58-4.6,8.49-1.11,2.32-2.07,4.72-3.14,7.06-.08.18-.49.33-.74.31-.34-.02-.74-.14-.98-.36-.91-.79-2.07-.8-3.14-1.03-.36-.08-.85.42-1.37.71.97.92,1.77,1.69,2.95,1.97.97.22,1.88.78,2.85.85.92.07,1.93-.14,2.8-.49,1.4-.57,2.74-1.32,4.06-2.06,1.39-.77,2.76-1.57,4.09-2.44,1.31-.85,2.51-1.85,3.83-2.68,1.98-1.26,4.09-2.27,6.36-2.94.86-.25,1.68-.6,2.52-.92.55-.21,1.08-.48,1.65-.65,1.09-.32,2.09-.93,3.3-.84.76.05,1.53-.01,2.3-.1.78-.09,1.68.07,2.2-.95.17.33.27.52.36.7.08,0,.16,0,.18-.02.66-.92,1.74-.72,2.62-.88,1.96-.34,3.91.02,5.84.47.85.2,1.73.23,2.6.34.19.02.38.06.55.14,2.61,1.3,5.32,2.37,7.79,3.97.88.57,1.92.89,2.66,1.71.7.77,1.49,1.46,2.18,2.24.94,1.06,2.06,1.69,3.46,1.98.58.12,1.08.7,1.56,1.13.36.33.63.77.94,1.15.45.55.34.84-.33,1.01-.73.18-1.71.07-1.59,1.43-1.27-.7-2.08-.04-3.07.6-1,.65-1.66,1.32-1.96,2.46-.13.5-.52.94-.8,1.41-.43.72-.91,1.41-1.25,2.17-.09.21.24.61.38.92.3-.15.77-.23.88-.46.46-1.01.76-2.09,1.22-3.1.12-.27.55-.43.86-.6.18-.1.46-.07.61-.19,1.08-.95,2.1-1.97,3.21-2.87.39-.32,1-.38,1.53-.5,1.38-.33,2.79-.63,4.13.1.93.51,1.83,1.08,2.7,1.68.97.66,1.93,1.24,3.1,1.54,1.15.3,2.22.97,3.3,1.52.13.07.25.49.18.57-1.07,1.24-2.2,2.38-3.8,3.02-.86.34-1.56,1.08-2.33,1.65-.71.52-1.39,1.08-2.1,1.59-.8.58-.38,1.23-.1,1.83.3.63.91.54,1.47.47.93-.13,1.85-.26,2.78-.39.04.12.09.23.13.35-.51.44-1.05.86-1.54,1.32-2.2,2.09-4.96,3.15-7.72,4.19-.65.24-1.45.22-2.01-.5-.2-.26-.6-.37-.92-.52-1.51-.69-2.81-1.62-3.67-3.09-.07-.12-.18-.31-.14-.37.5-.71.21-1.09-.47-1.44-.2-.1-.17-.59-.3-.88-.5-1.11-.33-2.28-.34-3.43,0-.31-.24-.69-.49-.88-.14-.11-.65,0-.78.18-.3.39-.67.9-.64,1.33.12,1.82.07,3.77,1.41,5.21.93.99,1.15,2.49,2.46,3.17.86.45,1.67,1.01,2.54,1.46.27.14.64.1.96.14-.46.23-.94.45-1.39.71-.15.09-.28.25-.38.41-.5.82-1.16,1.13-2.17,1.25-1.12.13-2.16.82-3.25,1.24-1.29.5-2.58.97-3.87,1.44-.1.04-.23.03-.33,0-1.36-.59-2.62-.03-3.9.3-.58.15-1.13.42-1.71.55-.46.1-.95.04-1.41.13-.74.16-1.45.47-2.19.57-.96.13-1.94.1-2.91.15-.21.01-.42.1-.62.17-1.19.38-2.45.62-3.53,1.2-1.14.62-2.31.41-3.45.48-1.09.07-2.22-.19-3.32-.39-1.12-.2-2.24-.42-3.31-.76-1.21-.39-2.41-.84-3.54-1.42-1.54-.78-3.06-1.64-4.5-2.59-.8-.52-1.69-1.05-1.96-2.13-.08-.34-.4-.64-.65-.92-1.35-1.52-2.78-2.94-4.7-3.78-.44-.19-.77-.65-1.1-1.03-.98-1.14-1.83-2.42-2.93-3.42-1.27-1.14-2.82-1.92-4.41-2.6-2.16-.92-4.36-.6-6.57-.56-.41,0-.82-.27-1.23-.43-.24-.09-.48-.32-.7-.29-.67.08-1.41.12-1.98.43-.9.49-1.81.53-2.78.56-1.29.04-2.57.17-3.85.33-.59.07-1.06.89-.86,1.44Zm22.4-17.89c.22.77.4,1.35.55,1.93.03.1-.05.29-.13.35-.62.4-1.26.78-2.07,1.26.56-1.21,1.04-2.23,1.65-3.55Zm.35-1.53c.44,1.07.86,2.1,1.29,3.15-.1.09-.22.19-.43.37-.12-.37-.21-.67-.32-.97-.11-.29-.16-.66-.37-.84-.6-.51-.59-1.03-.17-1.71Zm.14-.85c1.42.9,2.4,2.95,1.7,3.64-.57-1.22-1.13-2.41-1.7-3.64Zm.8-1.87c.29.8.55,1.52.83,2.31-.34-.31-.59-.58-.87-.79-.63-.47-.65-.76.04-1.52Zm1.12-1.5c.67,1.75,1.36,3.53,2.04,5.31-.16.12-.35.26-.79.6-.39-.91-.75-1.74-1.1-2.58-.22-.55-.39-1.13-.62-1.68-.38-.93-.32-1.14.47-1.65Zm2.28-3.36c.58,1.26,1.11,2.41,1.62,3.56.08.19.14.45.08.63-.27.81.15,1.41.57,2.01.14.21.27.43.43.68-.29.14-.5.25-.74.37-.32-.98-.56-1.95-1.49-2.52-.05.07-.11.13-.1.16.21.55.43,1.11.66,1.66q.48,1.16-.94,1.73c-.65-1.9-1.29-3.79-1.98-5.81.57-.75,1.22-1.61,1.88-2.47Zm2.62-3.04c1.14,2.88,2.18,5.5,3.24,8.16-.88.49-1.76.99-2.71,1.52-.34-.63-.93-1.23-.88-1.76.11-1.14-.36-1.98-.85-2.89-.22-.4-.4-.83-.53-1.27-.13-.41-.17-.85-.26-1.27-.12-.03-.24-.07-.36-.1.36-.35.72-.69,1.28-1.23.77,2.72,1.03,5.33,2.81,7.4.05-.3.1-.66-.05-.9-.62-1.02-1.14-2.07-1.43-3.23-.29-1.18-.57-2.35-.87-3.61.09-.12.28-.38.61-.82Zm4.72,7.65c-.26.11-.67.64-1.06.06-.35-.52-.51-1.17-.74-1.77-.17-.45-.28-.92-.46-1.36-.21-.49-.51-.95-.71-1.45-.46-1.13-.88-2.27-1.35-3.51.14-.25.36-.64.67-1.21,1.24,3.15,2.43,6.16,3.64,9.23Zm-2.23-10.98c.69,3.62,2.64,6.71,3.77,10.11-.38.18-.76.37-1.07.52-.35-.79-.74-1.6-1.05-2.43-.65-1.7-1.17-3.46-1.92-5.11-.49-1.06-.91-1.96.07-2.91.04-.04.08-.07.2-.18Zm1.4-1.24c1.4,3.62,2.8,7.22,4.22,10.9-.42.15-.89.31-1.4.49-.02-.31.02-.53-.05-.71-.31-.75-.66-1.49-.97-2.24-.94-2.25-2.15-4.41-2.54-6.86-.11-.66-.23-1.33.74-1.58Zm1.91-1.59c1.34,3.95,2.65,7.77,3.96,11.63-.28.2-.57.39-1.1.75-1.49-3.84-2.93-7.54-4.41-11.37.39-.26.95-.62,1.55-1.01Zm5.43,11.41c-.14.17-.42.22-.78.4-.35-.88-.72-1.71-1-2.58-.16-.49,0-1.12-.24-1.52-1.43-2.32-1.77-5-2.68-7.56h.8c.26.71.48,1.35.74,1.98.43,1.03.93,2.03,1.35,3.06.73,1.81,1.43,3.64,2.1,5.47.07.2-.12.55-.29.75Zm12.69-13.26c.19,1.35.33,2.72.61,4.05.31,1.43.75,2.83,1.15,4.24.41,1.42.33,1.64-.79,1.91-.1-.3-.24-.59-.31-.9-.26-1.23-.44-2.47-.75-3.68-.48-1.88-1.04-3.75-1.59-5.61-.06-.2-.29-.35-.44-.52-.05.25-.2.52-.14.73.68,2.47,1.4,4.92,2.08,7.39.22.8.32,1.63.48,2.42h-1.62c.08-.04.16-.07.24-.11-.38-1.44-.76-2.87-1.14-4.31-.13.03-.27.06-.4.09.34,1.45.67,2.9,1.03,4.46-.45.04-.95.08-1.52.13-.3-.89-.66-1.71-.86-2.57-.26-1.15-.32-2.35-.59-3.5-.39-1.65-.88-3.28-1.33-4.94.75,0,1.44,0,2.02,0,.17,1.46.34,2.88.52,4.44.27-.18.43-.24.43-.29-.1-1.38-.21-2.77-.32-4.05,1.04,0,2.2,0,3.36,0-.05.29-.13.45-.11.6Zm6.13,3.54c.15.75.4,1.48.51,2.23.23,1.53.41,3.07.6,4.58-.8.07-1.21-.25-1.28-1.11-.06-.86-.26-1.72-.41-2.57-.29-1.64-.6-3.27-.9-4.91-.04-.23-.06-.61-.19-.65-.21-.08-.5.05-.7.09,1.18,1.34.56,2.99,1.01,4.39.45,1.42.55,2.95.81,4.43-.12.06-.24.12-.35.18-.25-.31-.62-.58-.73-.93-.34-1.11-.56-2.27-.88-3.39-.32-1.12-.7-2.22-1.05-3.33-.04-.11.04-.26.02-.38-.05-.52-.09-1.04-.21-1.54-.03-.13-.3-.21-.46-.32-.08.18-.27.4-.24.55.34,1.38.72,2.74,1.08,4.11.42,1.63.84,3.25,1.27,4.94h-1.5c-.62-3.41-2.15-6.64-1.61-10.39,1.51.55,2.99,1.07,4.45,1.65.22.09.44.4.49.64.13.57.14,1.17.25,1.74Zm2.71,7.23c-.86-.24-1.31-.9-1.35-1.89-.09-2.06-.38-4.08-1.04-6.04-.07-.2,0-.43,0-.66.47.18.83.37,1.22.46.85.2.94.78.81,1.49-.06.32-.16.65-.14.97.09,1.46.2,2.92.33,4.38.03.42.12.84.19,1.3Zm.72-7.32c.42,2.53.84,5.06,1.25,7.59-.09.06-.17.13-.26.19-.41-.23-.94-.38-1.19-.73-.23-.3-.17-.83-.2-1.26-.07-1.1-.08-2.2-.18-3.3-.08-.86-.23-1.7.3-2.46l.28-.03Zm3,5.28c.13,1.1.37,2.2.57,3.29-.09.03-.19.05-.28.08-.68-.47-1.63-.57-1.73-1.77-.14-1.67-.08-3.39-.79-4.99-.15-.35-.14-.77-.24-1.34.6.37,1.01.74,1.48.89.8.25,1.17.71,1.16,1.53,0,.24,0,.47-.02.71-.05.53-.22,1.08-.16,1.6Zm4.75,5.24c.05.14.07.29.12.49-1.08-.35-1.4-1.17-1.57-2.09-.17-.93-.21-1.9-.5-2.8-.22-.67-.73-1.25-1.11-1.87-.09.04-.18.09-.27.13.06.23.08.48.19.69.25.51.65.97.8,1.5.21.75.23,1.55.37,2.32.09.52.26,1.03.39,1.56-.75-.52-1.46-1.01-2.12-1.47-.13-2.1-.26-4.19-.41-6.51.62.39.96.65,1.34.84,2.03,1.05,2.53,2.96,2.37,4.94-.07.88.17,1.52.41,2.24Zm1.27-1.71c.31,1.09.6,2.2.93,3.45-.5-.3-1.12-.45-1.33-.83-.85-1.54-.71-3.29-.83-4.98,0-.02.08-.05.2-.12.13.18.32.35.4.57.23.63.45,1.27.63,1.92Zm2.32,3.82c-.31-.13-.61-.25-.7-.29-.44-1.34-.83-2.54-1.25-3.84,1.3.24,2.07,2.91,1.95,4.13Zm2.61,1.81c-.07.05-.15.11-.22.16-1.35-.84-2.23-1.92-1.86-3.83.74,1.31,1.41,2.49,2.08,3.67Zm1.39,31.95c.42-.53,1.25-.72,1.89-1.07.06.09.12.19.18.28-.12,1.33-.4,2.59-1.4,3.6-.94-1-1.29-2.04-.68-2.81Zm-3.64,1.2c.41,1.05.06,1.88-.56,2.67.44-.81-1-2,.56-2.67Zm-1.96,4c.29-1.01-.38-2.2.52-3.08.09,1.09.65,2.27-.52,3.08Zm-.64-2.52c0,.96-.08,1.92.03,2.86.08.72-.24,1.06-.61,1.31-.08-.96-.15-1.93-.24-2.89-.06-.63-.01-1.18.83-1.28Zm-5.76,8.18c.25-2.31-.22-4.67.72-6.99.5-.07.75.2.72.9-.02.53.19,1.07.2,1.61,0,.63-.09,1.27-.14,1.9-.03.37-.06.73-.09,1.1,1.42-1.65.45-3.47.49-5.24.29-.08.53-.15.78-.22.14,1.08.28,2.09.42,3.16.76-.1.47-.76.46-1.18-.01-.73-.14-1.46-.22-2.21.43-.2.71-.33,1.03-.48.09,1.01.36,1.95.19,2.8-.15.73-.07,1.72-1.14,2.09-.78.27-.74,1.69-1.95,1.56-.12.85-.42,1.1-1.48,1.18Zm-3.44-.82c.09-1.33.28-2.66.57-3.96.11-.51-.24-1.51,1.01-1.41-.09,2.1-.19,4.19-.28,6.28,0,.21.09.43.15.64.08,0,.16-.01.25-.02.06-.22.15-.44.16-.66.07-1.92.12-3.85.17-5.77.02-.82.54-1.21,1.45-1.08-.55,1.8-.5,3.64-.46,5.48.03,1.26-.35,1.73-1.51,2.21-.42.18-.81.46-1.3.75-.08-.83-.27-1.66-.21-2.47Zm-3.6-3.71c.61-.2,1.07-.36,1.65-.55-.45,2.1-.4,4.15-.27,6.22.23-.52.33-1.04.38-1.57.13-1.34.26-2.69.36-4.04.07-.93.7-1.16,1.65-1.3-.15,1.12-.29,2.17-.44,3.22-.1.67-.3,1.34-.31,2.01-.01.84.13,1.69.21,2.6-.75.11-1.36.19-1.76.25-.53.32-.94.56-1.47.88,0-2.79,0-5.36,0-7.72Zm-2.03,7.91c.17-2.4.33-4.81.51-7.21.05-.64.37-.95,1.17-.7-.06.61-.16,1.2-.17,1.79-.02,1.51,0,3.02,0,4.54q0,1.46-1.37,1.92s-.05,0-.1-.02c0-.1-.03-.21-.03-.32Zm-2.2,1.74c.13-1.3.25-2.6.4-3.9.05-.4.27-.78.29-1.18.04-.89.01-1.79.01-2.69,0-1.33.06-1.4,1.49-1.76,0,.42.03.84,0,1.24-.09,1.12-.22,2.23-.32,3.35-.07.9,0,1.83-.21,2.7-.22.91-.29,2.06-1.67,2.24Zm-7.42,1.33c.14-.68.35-1.35.41-2.04.16-1.69.24-3.4.39-5.09.07-.81.21-1.6.32-2.41h1.39c-.53,2.73-1.04,5.42-1.54,8.01.02.02-.08-.1-.28-.35-.03.37-.11.61-.04.78.15.32.38.59.58.89.13-.32.33-.63.38-.97.18-1.22.27-2.45.45-3.67.14-.88.44-1.75.54-2.63.13-1.2.76-2.07,1.93-2.43.07-.02.13-.08.19-.13h0s0,0,0,0c.39-.06.77-.13,1.28-.21-.09.62-.28,1.15-.2,1.64.22,1.42-.02,2.76-.32,4.14-.17.8-.03,1.67-.03,2.51.07.01.15.03.22.04.1-.2.26-.4.28-.61.13-1.16.25-2.33.32-3.5.08-1.28.09-2.56.2-3.83.02-.25.36-.47.55-.7.2.22.56.43.57.66.05,1.23.03,2.46.02,3.69,0,.08-.06.15-.07.23-.2,1.35-.44,2.69-.57,4.05-.05.56-.12.84-.74.92-.69.09-1.35.36-1.94.53.06-1.17.16-2.32.16-3.48,0-1.19.14-2.32.57-3.46.32-.85.56-1.83-.28-2.62,0,0,0,0-.01,0,0,0,0,0,0,0-.07.25-.11.51-.21.75-.1.26-.36.49-.37.74-.08,2.04-.1,4.08-.2,6.12-.03.64-.21,1.28-.37,1.91-.04.15-.25.31-.42.36-.86.25-1.72.48-2.59.67-.37.08-.66-.04-.56-.52Zm-10.44-1.39c.66-2.55,1.37-5.12,1.97-7.72.17-.74.26-1.43.94-1.89.15-.1.19-.36.32-.63.55.16,1.09.32,1.64.48.8.24,1.22.99.99,1.8-.33,1.18-.68,2.35-1,3.53-.24.88-.46,1.76-.69,2.64.13.03.25.07.38.1.71-2.37,1.42-4.73,2.15-7.14,1,.14,1.97.29,2.77.4-.24,1.42-.42,2.87-.74,4.29-.32,1.42-.67,2.82-.29,4.28.57-2.81.52-5.74,1.71-8.41h.96c-.88,3.39-.22,6.95-1.39,10.09-1.15,0-2.13,0-3.14,0,0-1.17,0-2.24,0-3.3-.55.97-1.02,1.98-.66,3.18-.61-.03-1.14-.06-1.69-.09.15-1,.28-1.95.42-2.91-.1-.02-.19-.03-.29-.05-.29.93-.57,1.86-.85,2.76-.45-.05-.88-.1-1.23-.14.28-1.95.56-3.9.85-5.91-.66-.03-.63.5-.69.87-.26,1.63-.48,3.26-.73,5.02-.64-.48-1.18-.89-1.69-1.27Zm-3.42-1.62c.05-.51.18-1.01.29-1.51.23-1,.59-2,.68-3.01.18-2.07,1.35-3.77,1.9-5.84.95.46,1.8.83,2.59,1.29.7.4.67.63.06,1.13-.2.17-.44.39-.5.62-.26,1.08-.43,2.18-.69,3.26-.46,1.89-.96,3.77-1.44,5.66-.37-.18-.61-.3-.86-.43.13-.73.23-1.47.12-2.2-.12,0-.25,0-.37,0-.06.7-.12,1.39-.2,2.24-.51-.23-.95-.39-1.33-.63-.15-.09-.28-.38-.26-.57Zm-1.57-.54c.75-3.6,1.49-7.15,2.23-10.71,1.7.68,1.7.69,1.17,2.27-.07.21-.16.41-.24.61-.31.76-.73,1.49-.9,2.28-.45,2-.79,4.02-1.19,6.07-.45-.21-.76-.36-1.08-.51Zm-3.11-4.06c.37-1.51.92-2.97,1.34-4.47.39-1.41.71-2.83,1.06-4.29.78.55,1.54,1.07,2.28,1.64.12.09.14.39.11.57-.35,1.76-.73,3.51-1.1,5.27-.34,1.61-.67,3.21-1.05,4.99-.75-.62-1.35-1.11-1.98-1.62.25-.17.44-.23.49-.35.41-1.01.86-2,1.18-3.04.54-1.78,1.01-3.59,1.48-5.39.05-.18-.09-.42-.15-.62-.06.03-.12.05-.17.08-.94,2.97-1.89,5.95-2.83,8.92-.14-.01-.29-.03-.43-.04-.08-.55-.34-1.15-.22-1.65Zm-1.51-.78c.72-3.1,1.44-6.21,2.18-9.38.37.17.75.31,1.1.52.12.07.25.31.22.44-.32,1.34-.66,2.68-1.02,4.02-.31,1.17-.64,2.35-.96,3.52-.13.47-.26.95-.41,1.46-.43-.22-.72-.37-1.12-.57Zm-1.28-2.87c.38-1.86.77-3.71,1.16-5.57.03-.13.09-.25.15-.38.33-.71.67-1.41,1.1-2.32.19.6.52,1.11.47,1.58-.13,1.24-.39,2.46-.67,3.68-.29,1.26-.68,2.5-1,3.75-.13.5-.19,1.02-.3,1.61-.67-.74-1.11-1.44-.92-2.36Zm-1.35-2.79c.25-.7.49-1.42.65-2.15.26-1.15.46-2.32.7-3.48.11-.51.74-.69,1.2-.45.52.27.56.64.36,1.09-.76,1.69-1.13,3.48-1.5,5.27-.18.85-.35,1.7-.56,2.71-.63-1.06-1.24-1.88-.84-3Zm.65-7.32c.18.35.5.68.44.92-.46,1.97-.99,3.93-1.56,6.12-.9-1.75-.28-5.49,1.12-7.04Zm-2.67,2.15c.16-.98.51-1.92.79-2.88.36.17.72.34,1.11.52-.42,1.2-.85,2.41-1.37,3.89-.24-.63-.59-1.11-.53-1.52Zm-.52-2.75c.11-.03.15-.32.21-.49.07-.24.13-.48.24-.91.24.38.5.61.46.78-.2.96-.48,1.91-.8,3.13-.19-.58-.28-.92-.41-1.25-.21-.5-.58-1.01.3-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.26,42.81c1.14-.09,2.28-.21,3.43-.31.71-.06,1.41-.14,2.12-.17.9-.04,1.35-.59,1.2-1.5-.04-.26-.07-.53-.07-.58-1.15-.22-2.16-.45-3.18-.59-1.87-.25-3.74-.45-5.61-.68-.12-.01-.24-.07-.36-.11,0-.07-.01-.15-.02-.22.58-.11,1.16-.31,1.74-.3.9.01,1.79.19,2.69.27,1.61.14,3.23.26,4.84.36.2.01.41-.18.55-.44-.97-.05-1.93-.09-2.9-.14,0-.07,0-.14,0-.21.71-.12,1.45-.17,2.13-.4.29-.1.45-.57.68-.86-.28-.14-.54-.38-.83-.42-1.2-.15-2.4-.33-3.6-.31-1.86.03-3.77-.29-5.52.68-.12.07-.27.09-.36.18-.96.94-1.4,2.12-1.49,3.43-.02.21.3.48.51.67.47.4.96.77,1.33,1.06.83.16,1.53.28,2.23.42.18.04.35.19.52.17Zm-.53-5.07c1.04-.84,2.86-.64,4.1.47-1.43-.16-2.72-.31-4.1-.47Zm-1.47,1.85c2.25.17,4.28.33,6.32.49-1.9.96-5.09.56-6.32-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.92,24.5c-1.17-.47-2.38-.93-3.61-1.13-1.25-.2-2.59.12-3.75-.7.13-.92,1.31-1.72,2.32-1.56,1.87.31,3.63.97,5.21,1.97.89.56,1.6,1.4,2.37,2.14.08.08-.01.33-.04.66-.92-.52-1.67-1.05-2.5-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.69,27.85c-.12-.91.89-2.19,1.59-2.2.99-.01,1.73.9,1.72,2.1,0,1.25-.58,1.91-1.64,1.91-1.13.06-1.53-.74-1.67-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.85,29.26c-.46-.08-.81-.77-1.04-1.01.02-1.42.49-2.4.99-2.42.68-.03,2,1.13,2.01,1.76,0,.82-1.01,1.83-1.96,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.46,24.94h0s.05.06.07.1c-.02-.04-.05-.07-.07-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.25,25.5c1.81.73,3.61,1.48,5.41,2.24.12.05.16.3.29.55-.3,0-.51.06-.67-.01-.5-.23-.95-.55-1.46-.76-1.75-.71-3.52-1.39-5.28-2.07-.6-.23-1.21-.47-1.83-.62-.89-.22-1.81-.35-2.7-.54-.09-.02-.15-.13-.22-.24-.02-.04-.05-.07-.07-.1.05-.03.11-.09.16-.13.05-.04.1-.07.15-.07,1.19.23,2.4.44,3.57.76.91.25,1.78.63,2.66.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.22,49.7c-.41.3-1.01.43-1.54.45-.69.03-1.28-.4-1.28-1.09,0-.48.33-1.07.7-1.41.34-.3.92-.33,1.45-.5.65.64,1.12,2.22.67,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.32,35.2c.16.5.09,1.11-.06,1.63-.03.11-.81.04-1.25,0-.59-.05-1.16-.21-1.32-.86-.2-.85.62-2.12,1.61-2.49.34.56.8,1.1,1.01,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.45,35.51c.71.24.9.82.88,1.69,0,.74-.44,1.45-1.13,1.5-.86.06-1.06-.79-1.47-1.28-.2-.24-.25-.76-.14-1.06.28-.71,1.16-1.08,1.85-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.75,40.89c-.6.01-1.73-1.03-1.77-1.63-.04-.72.74-1.41,1.67-1.47.52-.03,1.16.57,1.14,1.18-.03.83-.35,1.89-1.04,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.39,31.47c.86.08,1.74-.04,2.6.04.69.06,1.36.3,2.04.46,0,.11,0,.22,0,.32-.21.05-.42.17-.62.15-2-.25-4-.48-5.99-.8-1.29-.21-2.55-.55-3.82-.87-.41-.11-.62-.39-.27-.64,1.26.31,2.41.6,3.58.86.82.19,1.65.4,2.48.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.69,43.37c.02-.23.09-.48.22-.68.38-.61.92-.32,1.41-.2.7.18.73.73.69,1.23,0,1.25-.15,1.5-1.04,1.71-.65.15-1.32-.31-1.29-.88.02-.39-.02-.79.01-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.87,35.07c-.45.29-.78.38-1.13-.07-.35-.45-.88-.78-.52-1.54.45-.95,1.34-1.01,2.12-1.31.79.92.54,2.25-.46,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.9,29.03c-.2-.29-.31-.85-.17-1.14.32-.64.83-1.18,1.25-1.75.94.62,1.23,1.45,1.14,2.39-.03.33-.26.84-.5.9-.6.16-1.32.19-1.73-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.14,34.34c3.49.66,6.93.14,10.41.32-.16.22-.37.47-.57.47-1.67.03-3.35,0-5.02,0-.21,0-.42,0-.63,0-1.25-.1-2.51-.19-3.76-.34-.16-.02-.29-.3-.43-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.28,32.68c.42.03.85.06,1.27.09.93.06,1.87.05,2.78.19,1.82.28,3.63.58,5.48.21.38-.08.79-.01,1.18-.01.03.07.05.14.08.22-.26.15-.52.42-.77.42-1.55,0-3.1-.06-4.65-.12-1.08-.04-2.17-.12-3.25-.2-.6-.04-1.2-.09-1.79-.2-.18-.03-.31-.27-.47-.42.05-.06.1-.12.15-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.95,28.91c1.79.82,3.73.94,5.63,1.25,1.1.18,2.21.32,3.31.51.25.04.47.25.71.39l-.11.23c-1.2-.16-2.41-.28-3.6-.5-2.17-.4-4.32-.86-6.48-1.32-.22-.05-.4-.28-.6-.43.03-.07.07-.14.1-.22.35.02.74-.05,1.04.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.29,28.47c-.91-.55-2.02-.76-3.03-1.15-.37-.14-.85-.31-.36-.76,1.04.41,2.02.79,3,1.19.73.29,1.43.7,2.18.89,1.43.35,2.88.57,4.32.87.16.03.29.25.43.38-.19.09-.39.28-.55.25-.72-.12-1.44-.26-2.13-.48-1.28-.41-2.65-.46-3.86-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.84,26.48c.18.06.33.18.51.25.64.26,1.27.61,1.94.74,1.09.22,1.77.68,1.84,1.61-.26-.15-.5-.22-.63-.38-.46-.58-1.12-.58-1.75-.73-.57-.13-1.1-.42-1.63-.66-.25-.12-.45-.36-.71-.44-1.37-.42-2.76-.8-4.13-1.23-.31-.1-.57-.34-.86-.51.05-.09.11-.17.16-.26.08-.01.17-.06.23-.03,1.68.54,3.36,1.09,5.04,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.09,22.16c-.26-.15-.5-.4-.78-.45-.63-.13-.61-.62-.44-.94.25-.46.65-1.11,1.06-1.16.82-.12,1.56.86,1.55,1.76,0,1.13-.42,1.36-1.4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.18,37.06c.26-.07.79.04.83.16.16.57-.34.38-.63.43-.11.02-.21.07-.31.09-2.49.46-4.98.86-7.52.74-.64-.03-1.01-.22-.82-.86.71.13,1.34.35,1.97.33,2.19-.07,4.36-.33,6.48-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.96,35.71c.91.31,1.78.44,2.78.32,1.84-.22,3.71-.21,5.57-.27.23,0,.46.11.69.17-.2.13-.39.35-.6.37-.99.1-1.98.13-2.97.22-1.97.18-3.94.33-5.97-.5.17-.11.38-.36.49-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.94,49.66c-.47-.08-1.2-.76-1.18-1.14.03-.59.61-1.15.97-1.75.86.63,1.85,1,1.52,2.04-.12.41-.92.92-1.32.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.22,33.12c-.06.77-.62.92-1.27,1.09-.17-.09-.46-.14-.52-.28-.18-.48-.35-.98-.38-1.48-.03-.54.79-1.34,1.19-1.28.62.1,1.06,1.01.99,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.29,48.89c-.15,0-.38-.12-.44-.25-.17-.42-.46-.91-.37-1.3.11-.49.5-.94.88-1.3.07-.07.72.26.91.53.47.66.45,1.41.11,2.19-.4.05-.75.13-1.09.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.16,38.61c.01.6-.41.92-.89,1.01-.71.12-1.58-.62-1.61-1.54.24-.32.52-.96,1.01-1.27.4-.25,1.48,1.09,1.49,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.35,22.61c.36-.53.77-1.17,1.32-1.38.53-.22,1.14,1.03,1,1.95-.12.82-.65.7-1.22.55-.32-.08-.65-.07-1.12-.12,0-.37-.13-.78.03-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.69,30.77c-.47,0-.79-.09-.64-.5.16-.41.59-.98.92-1,.95-.04,1.56.8,1.46,2-.63-.2-1.19-.5-1.74-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.33,64.87c.29-1.57.58-3.13.88-4.77.95.52.38,1.24.39,1.83,0,.21-.11.43-.17.65-.76-.33-.41.39-.44.56-.08.38.03.8,0,1.21-.02.22-.16.44-.24.65-.14-.04-.28-.08-.42-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.47,59.12c.09.23.31.49.26.68-.27,1.06-.61,2.11-.92,3.16-.05.17-.11.35-.17.52-.14-.09-.28-.19-.42-.28.33-1.33.67-2.65,1-3.98.08-.03.16-.06.24-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.23,57.39c-.43,2.58-1.51,4.99-2.24,7.5.24-2.62,1.37-5.01,1.72-7.6.18.04.35.07.53.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.76,17.27c-.07,0-.21-.33-.26-.53-.11-.43-.18-.88-.27-1.38.84-.36.94-.31,1.13.54.03.15.17.29.18.44.02.22.05.51-.07.64-.16.17-.46.27-.7.29Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggvar);
export default __webpack_public_path__ + "static/media/piggvar.3605bfe4ac5e07755cf80a7a96e19c12.svg";
export { ForwardRef as ReactComponent };